/** Header height in pixels. Used for layout calculations (e.g. sticky subheaders that sit below it). */
export const HEADER_HEIGHT_PX = 60

/** Mobile header height in pixels. */
export const MOBILE_HEADER_HEIGHT_PX = 52
